// @core/api/endpoints/secret/delete_pki_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/secret';

/**
 * Delete PKI role
 * Deletes a PKI role. Existing certificates issued under this role are not affected.
 */
export async function DeletePkiRole(
  engine_id: string,
  role_name: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/roles/:role_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':role_name', encodeURIComponent(role_name));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
